import { HStack, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

const Document = ({ name, link, lastItem }: { name: string; link: string; lastItem: boolean }) => {
  const [hover, setHover] = React.useState(false);
  return (
    <HStack
      as="a"
      borderBottomColor={'blackAlpha.100'}
      borderBottomWidth={lastItem ? '0px' : '1px'}
      href={link}
      justifyContent="space-between"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      padding="10px"
      rel="noreferrer"
      target="_blank"
      width="100%">
      <TextBlock color={hover ? 'blue.500' : 'black'} fontSize="20px">
        {name}
      </TextBlock>
      <Icon icon="arrow-up-right-from-square" color="blue.500" />
    </HStack>
  );
};

type DocumentsProps = {
  documents: [name: string, link: string][];
};

export const Documents: React.FC<DocumentsProps> = ({ documents }) => {
  return (
    <VStack borderRadius={'10px'} borderColor="blackAlpha.100" borderWidth={'1px'} padding="10px">
      {documents.map(([name, link], i) => (
        <Document key={name} name={name} link={link} lastItem={i === documents.length - 1} />
      ))}
    </VStack>
  );
};
